module.exports = __webpack_public_path__ + "static/img/James-Sicily.86a277d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/James-Sicily.jpg
// module id = 5Gj5
// module chunks = 0